<template>
  <div>
    <v-card
      @click="openInteractionsDialog()"
      elevation="2"
      height="28px"
      style="width: 28px"
      class="pa-0 ma-0"
    >
      <v-row
        align="center"
        justify="center"
        class="pa-0 ma-0"
        style="height: 100%; width: 100%"
      >
        <!-- <v-img class="pa-0 ma-0" :src="interactions" max-width="24px"></v-img> -->
        <v-icon color="primary">{{ "$vuetify.icons.interactions" }}</v-icon>
      </v-row>
    </v-card>
    <vetalfa-drugs-interactions
      :triggerModel="model"
    ></vetalfa-drugs-interactions>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import images from "@/constants/images.js";
import DrugsInteractions from "@/components/complete/DrugsInteractions.vue";
export default {
  name: "DrugsInteractionsButton",
  components: { "vetalfa-drugs-interactions": DrugsInteractions },
  computed: {},
  props: {},
  methods: {
    ...mapActions("general", ["logEvent"]),
    openInteractionsDialog() {
      this.logEvent("interactions_btn_click");
      this.model = this._getTimestamp();
    },
  },
  computed: {},
  data() {
    return {
      interactions: images.INTERACTIONS,
      model: null,
    };
  },
};
</script>